import { render, staticRenderFns } from "./archive.vue?vue&type=template&id=258bebbc&scoped=true&"
import script from "./archive.vue?vue&type=script&lang=js&"
export * from "./archive.vue?vue&type=script&lang=js&"
import style0 from "./archive.vue?vue&type=style&index=0&id=258bebbc&prod&lang=less&"
import style1 from "./archive.vue?vue&type=style&index=1&id=258bebbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258bebbc",
  null
  
)

export default component.exports